module.exports = __webpack_public_path__ + "static/img/4.95b8e9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buliding/4.png
// module id = pp6+
// module chunks = 1